import {
  PeriodRangeChangeMeta,
  PeriodRangePicker,
} from '@app/components/period-range-picker/period-range-picker';
import { useAnalytics } from '@app/services/analytics/AnalyticsContext';
import { InsightsTimePeriod } from '@shared/api/types';
import { useInsightsPeriodRange } from '../hooks/use-insights-filters';

type Props = {
  /** The applied window echoed by the insights response — shown (and
   *  highlighted) when no explicit selection is in the URL. */
  defaultStart?: InsightsTimePeriod | null;
  defaultEnd?: InsightsTimePeriod | null;
};

/**
 * The insights page's period range picker: binds the shared picker to the
 * page's URL-backed period selection and tracks committed changes.
 */
export function InsightsPeriodPicker({ defaultStart, defaultEnd }: Props) {
  const [range, setRange] = useInsightsPeriodRange();
  const { track } = useAnalytics();

  const handleChange = (
    start: string | null,
    end: string | null,
    meta?: PeriodRangeChangeMeta
  ) => {
    setRange({ periodStart: start, periodEnd: end });
    if (meta) {
      track('Changed PG Insights Period', {
        selection_type: meta.selectionType,
        period_start_date: meta.startDate,
        period_end_date: meta.endDate,
      });
    }
  };

  return (
    <PeriodRangePicker
      start={range.periodStart}
      end={range.periodEnd}
      onChange={handleChange}
      defaultStart={defaultStart}
      defaultEnd={defaultEnd}
    />
  );
}
